import React, { Component } from "react";
import Logo from "../components/Logo";
import Button from "../components/Button";
import Loading from "../components/Loading";
import { css } from "aphrodite";
import { styles } from "./LoginPageStyles";
import ErrorMessage from "../components/ErrorMessage";

//import { Field, reduxForm, initialize } from 'redux-form';
import { connect } from "react-redux";
import { userActions } from "../_actions";

class LoginPage extends Component {
  constructor(props) {
    super(props);

    // reset login status
    this.props.dispatch(userActions.logout());

    this.state = {
      username: "",
      password: "",
      submitted: false
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(e) {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  }

  handleSubmit(e) {
    e.preventDefault();

    this.setState({ submitted: true });
    const { username, password } = this.state;
    const { dispatch } = this.props;
    if (username && password) {
      dispatch(userActions.login(username, password));
    }
  }

  render() {
    const { loggingIn, alert } = this.props;
    const { username, password, submitted } = this.state;

    return (
      <div className={css(styles.background)}>
        <div className={css(styles.loginWrapper)}>
          <Logo size={"large"} />

          <form
            name="form"
            className={css(styles.form)}
            onSubmit={this.handleSubmit}
          >
            <div className={css(styles.formInputs)}>
              <div className={css(styles.inputWrapper)}>
                <label className={css(styles.label)} htmlFor="username">
                  Username
                </label>
                <input
                  type="text"
                  className={css(styles.input)}
                  name="username"
                  placeholder="Username"
                  value={username}
                  onChange={this.handleChange}
                />
                {submitted && !username && (
                  <div className="help-block">Username is required</div>
                )}
              </div>
              <div className={css(styles.inputWrapper)}>
                <label className={css(styles.label)} htmlFor="password">
                  Password
                </label>
                <input
                  type="password"
                  className={css(styles.input)}
                  name="password"
                  placeholder="Password"
                  value={password}
                  onChange={this.handleChange}
                />
                {submitted && !password && (
                  <div className="help-block">Password is required</div>
                )}
              </div>
            </div>
            <Button type={"submit"} title={"Log In"} />
            {loggingIn && <Loading title={"Logging In"} onDark={true} />}
            {alert.message && (
              <ErrorMessage
                message={[
                  "Wrong username or password, please try again. ",
                  <a
                    className={css(styles.inlineErrorLink)}
                    href="/forgot-password"
                  >
                    Forgot your password?
                  </a>,
                  "."
                ]}
              />
            )}
          </form>

          <div className={css(styles.inlineLinkWrapper)}>
            <a className={css(styles.inlineLink)} href="/forgot-password">
              Forgot password?
            </a>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { loggingIn } = state.authentication;
  const { alert } = state;
  return {
    loggingIn,
    alert
  };
}

export default connect(mapStateToProps)(LoginPage);

// const connectedLoginPage = connect(mapStateToProps)(LoginPage);
// export { connectedLoginPage as LoginPage };
